"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoolioControlMode = void 0;
var CoolioControlMode;
(function (CoolioControlMode) {
    CoolioControlMode[CoolioControlMode["Off"] = 1] = "Off";
    CoolioControlMode[CoolioControlMode["Pwm"] = 2] = "Pwm";
    CoolioControlMode[CoolioControlMode["Rpm"] = 3] = "Rpm";
})(CoolioControlMode = exports.CoolioControlMode || (exports.CoolioControlMode = {}));
